import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-business-discounted-payback-period-calculator',
  templateUrl: './business-discounted-payback-period-calculator.component.html',
  styleUrls: ['./business-discounted-payback-period-calculator.component.css']
})
export class BusinessDiscountedPaybackPeriodCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    } )

  } 
  pvm(n1,n2,n3){
    var pvmVa=(n1)/(Math.pow((1+n2),n3));
    var pvmVasimple=  pvmVa.toFixed(2);
    return pvmVasimple ;
    }
}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/business-discounted-payback-period-calculator/business-discounted-payback-period-calculator.component.ts